import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import {useState} from "react";
import EmojiPicker, {type EmojiSelection} from "../../common/emojiPicker/EmojiPicker";

const INITIAL_MESSAGE = "Your table is ready ";

const EmojiPickerTestPage = () => {
    const [message, setMessage] = useState(INITIAL_MESSAGE);
    const [selectedEmoji, setSelectedEmoji] = useState<EmojiSelection>();

    const selectEmoji = (emoji: EmojiSelection) => {
        setSelectedEmoji(emoji);
        setMessage(current => `${current}${emoji.emoji}`);
    };

    return (
        <Box
            sx={{
                width: "100%",
                minHeight: 0,
                overflowY: "auto",
                bgcolor: "background.default",
                px: {xs: 2, md: 6},
                py: {xs: 3, md: 5},
            }}
        >
            <Stack gap={3} sx={{width: "100%", maxWidth: 960}}>
                <Box>
                    <Typography variant="h4">Frimousse emoji picker</Typography>
                    <Typography variant="body2" color="text.secondary" sx={{mt: 0.5, maxWidth: 720}}>
                        Frimousse supplies the accessible picker behavior and emoji data. The layout,
                        colors, focus treatment, and form controls below use the dashboard MUI theme.
                    </Typography>
                </Box>

                <Alert severity="warning" variant="outlined" sx={{maxWidth: 720}}>
                    Frimousse 0.3.0 officially requires TypeScript 5.1 or newer. This dashboard still
                    uses TypeScript 4.9.5, so this page is also a compatibility check against the
                    current project toolchain.
                </Alert>

                <Stack
                    direction={{xs: "column", md: "row"}}
                    gap={{xs: 3, md: 5}}
                    alignItems="flex-start"
                >
                    <EmojiPicker autoFocus={false} onSelect={selectEmoji}/>

                    <Stack gap={2} sx={{width: "100%", maxWidth: 420, pt: {md: 1}}}>
                        <Box>
                            <Typography variant="h6">Selection result</Typography>
                            <Typography variant="body2" color="text.secondary">
                                Pick an emoji to append it to the mocked message field.
                            </Typography>
                        </Box>

                        <TextField
                            label="Message"
                            multiline
                            minRows={4}
                            value={message}
                            onChange={event => setMessage(event.target.value)}
                            fullWidth
                        />

                        <Stack direction="row" alignItems="center" justifyContent="space-between" gap={2}>
                            <Typography variant="body2" color="text.secondary" noWrap>
                                {selectedEmoji
                                    ? `Last selected: ${selectedEmoji.emoji} ${selectedEmoji.label}`
                                    : "No emoji selected yet"}
                            </Typography>
                            <Button
                                size="small"
                                disabled={!selectedEmoji && message === INITIAL_MESSAGE}
                                onClick={() => {
                                    setSelectedEmoji(undefined);
                                    setMessage(INITIAL_MESSAGE);
                                }}
                            >
                                Reset
                            </Button>
                        </Stack>
                    </Stack>
                </Stack>
            </Stack>
        </Box>
    );
};

export default EmojiPickerTestPage;
